import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { httpsCallable } from 'firebase/functions';
import { auth, functions } from '../firebase';
import { withRef } from '../utils/refLink';

/* ═══════════════════════════════════════════════════════════════
   useLangganan — SATU takrifan laluan "tekan Langgan → bayar".

   KENAPA WUJUD (bug jualan, disahkan pada production 2026-08-29):
   Halaman jualan (SalesPageView) dahulunya menyambung butang Langgan
   kepada `handleCTA` — fungsi yang TIDAK menerima apa-apa maklumat dan
   hanya `navigate('/pricing')`. Jadi pilihan pelanggan (tick add-on
   Flow Ultra, module SMART, nama pakej) DIBUANG, dan tiada bil pernah
   dicipta. Diuji hidup: tekan "Langgan — RM299" di sesaat.ai cuma
   menukar halaman. Pembeli baharu terpaksa menekan TIGA kali merentas
   tiga halaman sebelum sampai Billplz — kebanyakan berhenti di tekan
   pertama kerana ia nampak seperti butang rosak.

   ⛔ Dua halaman menjual pakej yang SAMA (halaman jualan + halaman
      harga). Menyalin logik ini ke dua tempat bermakna satu salinan
      akan tertinggal bila harga/pakej berubah, dan kegagalannya SENYAP
      — pelanggan dicaj salah atau tidak dicaj langsung. Sebab itu ia
      hidup di sini, bukan dalam komponen.
   ═══════════════════════════════════════════════════════════════ */
export default function useLangganan() {
    const navigate = useNavigate();
    const [payLoading, setPayLoading] = useState(false);

    // sesaat.ai = domain marketing sahaja — login & bayaran WAJIB berlaku di
    // app.sesaat.ai (auth Firebase tak dikongsi antara domain; bayaran dari
    // sesaat.ai buat Billplz return ke domain salah).
    const isMainDomain = window.location.hostname === 'sesaat.ai'
        || window.location.hostname === 'www.sesaat.ai';

    // withRef: bawa kod ejen merentas domain — cookie hilang bila pelanggan
    // bertukar browser (WhatsApp → Safari, kerap di iOS). Lihat utils/refLink.js.
    const goLogin = () => {
        if (isMainDomain) { window.location.href = withRef('https://app.sesaat.ai/login'); return; }
        navigate('/login');
    };

    /** planKey: 'premium' | 'fighter' | 'smart' | 'smart_upgrade' | 'premium_renew_flownity'
     *  opts: { wantFlowAddon, smartModule } */
    const langgan = async (planKey = 'premium', opts = {}) => {
        if (payLoading) return;

        // ⛔ Dulu dipaku 'premium' sahaja — tick add-on pada pakej Fighter dan SMART
        //    hilang senyap sebelum sampai ke server (pelanggan tick, tapi tak dicaj
        //    dan tak dapat apa-apa).
        const wantFlowAddon = (planKey === 'premium' || planKey === 'fighter' || planKey === 'smart')
            && !!opts.wantFlowAddon;
        const smartModule = planKey === 'smart' ? (opts.smartModule || '') : '';

        if (isMainDomain) {
            // sesaat.ai → app.sesaat.ai: pilihan pelanggan dibawa dalam alamat,
            // kalau tidak dia terpaksa memilih semula di seberang sana.
            const q = new URLSearchParams();
            if (wantFlowAddon) q.set('flowultra', '1');
            if (smartModule) q.set('smod', smartModule);
            const ekor = q.toString() ? '?' + q.toString() : '';
            window.location.href = withRef('https://app.sesaat.ai/pricing' + ekor);
            return;
        }

        // Belum daftar/log masuk → hantar ke pendaftaran dahulu. Pilihannya kekal
        // dalam sessionStorage (origin sama), jadi selepas daftar dia sampai ke
        // gate langganan dengan tick masih bertanda.
        if (!auth.currentUser) { goLogin(); return; }

        setPayLoading(true);
        try {
            const createBill = httpsCallable(functions, 'createBillplzBill');
            // Map planKey → param createBillplzBill (bundle = plan premium + flag wantFlownityAddon)
            const payload = planKey === 'premium_renew_flownity'
                ? { returnOrigin: window.location.origin, plan: 'premium', wantFlownityAddon: true }
                : { returnOrigin: window.location.origin, plan: planKey, wantFlowAddon, ...(smartModule ? { smartModule } : {}) };
            const res = await createBill(payload);
            const url = res?.data?.url;
            if (!url) throw new Error('URL bayaran tiada');
            window.location.href = url; // redirect ke halaman bayar Billplz
        } catch (err) {
            console.error('[Billplz] gagal mula bayaran:', err);
            setPayLoading(false);
            // Guard server (addon/bundle/pakej) hantar mesej BM formal — papar terus pada pengguna.
            const knownCode = err?.code === 'functions/failed-precondition' || err?.code === 'functions/already-exists';
            alert(knownCode && err?.message ? err.message : 'Maaf, ada masalah memulakan pembayaran. Sila cuba lagi atau hubungi admin.');
        }
    };

    return { payLoading, langgan, goLogin, isMainDomain };
}
